import React from 'react';
import classes from './ToggleSwitch.module.css';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  size = 'medium'
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const switchClass = `${classes.toggleSwitch} ${classes[size]} ${
    checked ? classes.checked : ''
  } ${disabled ? classes.disabled : ''}`;

  const sliderClass = `${classes.slider} ${checked ? classes.sliderChecked : ''}`;

  return (
    <div className={switchClass} onClick={handleToggle}>
      <div className={sliderClass} />
    </div>
  );
};

export default ToggleSwitch; 